/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect} from "react";
import {Link} from "react-router-dom";
import Loader from "../Common/Loader";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ActivateCard from "./ActivateCard";
import CardContext from "../../Context/CardContext";
import Pagination from "../Common/Pagination";
import StudentCardSearchForm from "../Common/StudentCard/StudentCardSearchForm";

function InactiveCards(props) {
  const [modal, setModal] = useStateCallback(false);
  const {page, inactivePage,  inactiveMeta, setInactivePage, inactiveFirst, inactiveQuery, setInactiveQuery, loading, loading2, inactiveCardList, getInactiveCards, getCards,
    searchInactiveCard} = useContext(CardContext);
  
  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= inactiveMeta) {
      setInactivePage(newPage);
    }
  };

    const setCards = (e) => {
      e.preventDefault();
      setInactiveQuery("");
      setInactivePage(1);
      getInactiveCards(1);
    };
  
    useEffect(() => {
      if (inactiveQuery) {
        searchInactiveCard();
      } else {
        getInactiveCards(inactivePage);
      }
    }, [inactivePage]);

  const cardOn=(e,item)=>{
    setModal(false, ()=>setModal(<ActivateCard cardID={item.card_id} page={page} inactivePage={inactivePage} getAllCards={getCards} getInactiveCards={getInactiveCards} isOpen={true}/>))
  }

 

    return (
        <>
      {modal}
      
        <StudentCardSearchForm searchTerm={inactiveQuery} setSearchTerm={setInactiveQuery} searchCards={searchInactiveCard} setCards={setCards} setPage={setInactivePage} placeholder="Enter card / wristband number or name of student..."/>
        <div className="table-responsive">
{loading || loading2 ? (
<Loader /> 
) : (
<table className="table display data-table text-nowrap">
<thead>
<tr>
<th scope="col" className="wd-10p">No.</th>
<th>Serial Number</th>
<th>Type</th>
<th>Student Name</th>
<th>Status</th>
<th>Actions</th>
</tr>
</thead>
<tbody>
{inactiveCardList.length > 0 ? (
inactiveCardList.map((item, index) => (
  <tr key={index}>
    <th scope='row' style={{width:"5px"}}>{index + inactiveFirst + 1}</th>
    <td>{item.card_number}</td>
    <td>{item.type==="CARD"?<span class="badge badge-info">{item.type}</span>:<span class="badge badge-wb">{item.type}</span>}</td>

          <td>{item.student?.full_name?item.student.full_name:"Not assigned"}</td>
          <td><span class="badge badge-danger">Inactive</span></td>
          <td>
            <div className="dropdown">
              <Link
                to="#"
                className="dropdown-toggle"
                data-toggle="dropdown"
                aria-expanded="false">
                <span className="flaticon-more-button-of-three-dots"></span>
              </Link>
              <div className="dropdown-menu dropdown-menu-right">
              
              <Link
                className="dropdown-item"
                to="#"
                onClick={(e) => cardOn(e,item)}>
                <i className="fa fa-power-off mr-1" style={{color:"green"}}></i>
                Re-Activate / Unblock
              </Link></div>
            </div>
          </td>
  </tr>
))
) : (
<tr>
  <td colSpan="6" style={{ textAlign: "center" }}>
    No cards registered yet.
  </td>
</tr>
)}
</tbody>
</table>
)}
        </div>
        <Pagination currentPage={inactivePage} totalPages={inactiveMeta} onPageChange={handlePagination}/>

         </>
  );
}

export default InactiveCards;
